import React from 'react';
import { useCart } from '../../contexts/CartContext';
import './ProductCard.css';
import API_BASE_URL from '../../config/api';

const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  if (imageUrl.startsWith('http')) return imageUrl;
  return `${API_BASE_URL}${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
};

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { id, name, imageUrl, basePrice, memberPrice, categoryName, sportName, hasStock } = product;

  const isMember = !!localStorage.getItem('token');
  const displayPrice = isMember && memberPrice ? memberPrice : basePrice;
  const hasMemberDiscount = memberPrice && memberPrice < basePrice;

  const handleQuickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Quick add with first available variant — navigate to detail for variant selection
    window.location.href = `/loja/produto/${id}`;
  };

  const formatPrice = (val) => `${Number(val).toFixed(2)} €`;

  return (
    <article className="product-card" role="article">
      <a href={`/loja/produto/${id}`} className="product-card-link" aria-label={`Ver ${name}`}>
        {/* Image */}
        <div className="product-card-image-wrap">
          {imageUrl
            ? <img src={getImageUrl(imageUrl)} alt={name} className="product-card-img" loading="lazy" />
            : (
              <div className="product-card-placeholder">
                <i className="fas fa-tshirt" />
              </div>
            )
          }

          {/* Badges */}
          <div className="product-card-badges">
            {product.isFeatured && (
              <span className="product-badge product-badge--featured">Destaque</span>
            )}
            {!hasStock && (
              <span className="product-badge product-badge--sold-out">Esgotado</span>
            )}
            {hasMemberDiscount && hasStock && (
              <span className="product-badge product-badge--member">Sócio</span>
            )}
          </div>

          {/* Quick action overlay */}
          {hasStock && (
            <button
              className="product-card-quick-btn"
              onClick={handleQuickAdd}
              aria-label={`Adicionar ${name} ao carrinho`}
            >
              <i className="fas fa-shopping-bag" /> Comprar
            </button>
          )}
        </div>

        {/* Info */}
        <div className="product-card-info">
          <div className="product-card-meta">
            <span className="product-card-category">{sportName || categoryName}</span>
          </div>
          <h3 className="product-card-name">{name}</h3>
          <div className="product-card-pricing">
            <span className="product-card-price">{formatPrice(displayPrice)}</span>
            {isMember && hasMemberDiscount && (
              <span className="product-card-original">{formatPrice(basePrice)}</span>
            )}
          </div>
        </div>
      </a>
    </article>
  );
}
